// apps/roleforge-app/src/components/respond/RespondSidebar.tsx
//
// Phase 10 Task 10.2 — left rail of the stakeholder chat shell. Brand image
// at top, "What we're covering" indicator dots in the middle, recipient hint
// (their voice label + "Step away anytime") in the footer.

export interface SectionState {
  label: string;
  state: 'active' | 'pending' | 'covered';
}

interface Props {
  voiceLabel: string;
  sections: SectionState[];
}

export function RespondSidebar({ voiceLabel, sections }: Props) {
  return (
    <aside className="dark-surface sticky top-0 z-30 flex h-screen w-64 shrink-0 flex-col border-r border-line bg-surface text-ink">
      <div className="border-b border-line">
        <div className="px-4 py-4">
          <img
            src="/roleforge-logo-horizontal.svg"
            alt="RoleForge"
            className="block w-full h-auto"
          />
        </div>
      </div>
      <nav className="min-h-0 flex-1 overflow-y-auto px-3 py-5">
        <h3 className="px-3 pb-3 text-[10px] font-semibold uppercase tracking-[0.18em] text-graphite">
          What we're covering
        </h3>
        <div className="flex flex-col gap-1">
          {sections.map((s) => {
            const dotClass =
              s.state === 'active'
                ? 'bg-coral'
                : s.state === 'covered'
                  ? 'bg-mint'
                  : 'bg-slate-700';
            const labelClass =
              s.state === 'active'
                ? 'text-coral'
                : s.state === 'covered'
                  ? 'text-mint'
                  : 'text-slate-400';
            return (
              <div
                key={s.label}
                data-state={s.state}
                className="flex items-center gap-3 rounded-xl px-3 py-2.5"
              >
                <span aria-hidden className={`h-2 w-2 rounded-full ${dotClass}`} />
                <span className={`text-sm font-semibold ${labelClass}`}>
                  {s.label}
                </span>
              </div>
            );
          })}
        </div>
      </nav>
      <div className="border-t border-line px-4 py-4 text-xs text-graphite">
        <div className="font-semibold text-ink">{voiceLabel}</div>
        <div className="mt-1">Step away anytime — we'll pick up where we left off.</div>
      </div>
    </aside>
  );
}
